module.exports = __webpack_public_path__ + "static/media/YM05_0.409613e2.jpg";